
import "@sparta.help.modules/engagement-search-module/dist/styles.css"
import "@sparta.help.modules/info-link-tiles-module/dist/styles.css"
import "@sparta.global.modules/connect-with-us-module/dist/styles.css"
import "@sparta.help.modules/single-column-content-module/dist/styles.css"


import spartaBootstrapUtility from "@sparta.global.utilities/sparta-bootstrap-utility/dist/es6.js"
import tagManagerUtility from "@sparta.global-vtim.utilities/tag-manager-utility/dist/es6.js"
import secureLinkUtility from "@sparta.global.utilities/secure-link-utility/dist/es6.js"

import "@sparta.help.modules/engagement-search-module/dist/es6.js"
import "@sparta.help.modules/info-link-tiles-module/dist/es6.js"
import "@sparta.global.modules/connect-with-us-module/dist/es6.js"
import "@sparta.help.modules/single-column-content-module/dist/es6.js"


window.spaParams = window.spaParams || {};
window.spaParams.dynamicImportMap = {
  modules: [

  ],
}




// Add fingerprint spa-map.json into spaParams

// Initialize page
;(async function() {
  console.log('INIT PAGE')
  console.log('before - execute boot functions')
  await spartaBootstrapUtility.init(arguments);
secureLinkUtility.run()
  console.log('after - execute boot functions')
})();
